import { Button } from '@farol-ds/react'

import { parseErrorMessage } from '../../../utils/parseErrorMessage'
import { EmailField } from '../../email-field'
import { LoginCard } from '../../login-card'
import { ChangeEmailSubmitInput, useChangeEmailForm } from '../hooks'
import styles from './change-email.module.scss'

export type { ChangeEmailSubmitInput }

export interface ChangeEmailProps {
  currentEmail?: string
  isLoading?: boolean
  error?: string
  onSubmit: (input: ChangeEmailSubmitInput) => Promise<void> | void
  onCancel?: () => void
}

export function ChangeEmail(props: ChangeEmailProps) {
  const { currentEmail, isLoading, error, onSubmit, onCancel } = props

  const { newEmail, confirmEmail, handleSubmit } = useChangeEmailForm({
    onValidSubmit: onSubmit,
    currentEmail,
  })

  const parsedError = error ? parseErrorMessage(error) : null
  const header = {
    title: 'Alterar e-mail',
    ...(parsedError && {
      errorMessage: {
        title: parsedError.title,
        description: parsedError.description,
      },
    }),
  }

  return (
    <LoginCard header={header} hideCloseButton>
      <form onSubmit={handleSubmit} className={styles.form} noValidate>
        <EmailField
          label="Novo endereço de e-mail"
          name="new-email"
          value={newEmail.value}
          onChange={newEmail.onChange}
          onBlur={newEmail.onBlur}
          error={newEmail.error}
          disabled={isLoading}
        />

        <EmailField
          label="Confirme seu e-mail"
          name="confirm-new-email"
          value={confirmEmail.value}
          onChange={confirmEmail.onChange}
          onBlur={confirmEmail.onBlur}
          error={confirmEmail.error}
          disabled={isLoading}
        />

        <div className={styles.actions}>
          {onCancel && (
            <Button type="button" kind="tertiary" disabled={isLoading} onClick={onCancel}>
              Cancelar
            </Button>
          )}
          <Button type="submit" kind="primary" loading={isLoading}>
            Alterar
          </Button>
        </div>
      </form>
    </LoginCard>
  )
}
